import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import openNotification from "../../utils/notification";
import Utils from "../../utils";
import {ACCOUNT_INVOICE, ACCOUNT_ME_INVOICE} from "../../constants/AuthConstant";
import {cloneDeep} from "lodash";
import {HSM, SIGN_SERVER} from "../../views/app-views/admin/settings/electronic-invoice/invoidConstant";
import {INVOICE_RELEASE} from "../../constanst";
import InvoiceService from "../../services/InvoiceService";

const initialState = {
  isLoading: false,
  templateList: [],
  storeInvoice: null,
  orderInvoice: null,
  invoiceOrder: {
    invoiceList: [],
    totalInvoicePending: 0,
    totalInvoiceExported: 0,
  },
}

export const loginSInvoice = createAsyncThunk(
  "invoice/login",
  async (data, {rejectWithValue}) => {
    try {
      const {onSuccess} = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await InvoiceService.loginSInvoice(payload);
      if (response.access_token) {
        localStorage.setItem(ACCOUNT_INVOICE, JSON.stringify({...response, ...payload}));
      }

      if (onSuccess) onSuccess(response);
      return response;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getAllTemplate = createAsyncThunk(
  "invoice/getAllTemplate",
  async (taxCode, {rejectWithValue}) => {
    try {
      return await InvoiceService.getAllInvoiceTemplates(taxCode);
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const upSetInvoice = createAsyncThunk(
  "invoice/upSetInvoice",
  async (data, {rejectWithValue}) => {
    try {
      const {showNotification = true} = data;
      const payload = cloneDeep(data);
      delete payload.showNotification;
      const response = await InvoiceService.upsetStoreInvoice(payload);
      if (showNotification) {
        openNotification(
          "success",
          Utils.setLocale("admin.settings.popup.notification.success"),
          Utils.setLocale("admin.settings.popup.notification.title")
        );
      }
      return response;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const changeInvoicePartner = createAsyncThunk(
    "invoice/changeInvoicePartner",
    async (data, {rejectWithValue}) => {
      try {
        const response = await InvoiceService.changeInvoicePartner(data);
        return response;
      } catch (e) {
        return rejectWithValue(e.message || "Error");
      }
    }
);

export const upSetOrderInvoice = createAsyncThunk(
  "invoice/upSetOrderInvoice",
  async (data, {rejectWithValue}) => {
    try {
      const {onSuccess} = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await InvoiceService.upsetOrderInvoice(payload);
      const messageNoti = payload.cancelRequest ? "cancelRequest" : "sendRequest";
      openNotification(
        "success",
        Utils.setLocale(`admin.settings.popup.notification.${messageNoti}`),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      if (onSuccess) onSuccess(response);
      return response;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getStoreInvoice = createAsyncThunk(
  "invoice/getStoreInvoice",
  async (storeId, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.getStoreInvoice(storeId);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getOrderInvoice = createAsyncThunk(
  "invoice/getOrderInvoice",
  async (orderId, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.getOrderInvoice(orderId);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getCustomerInvoice = createAsyncThunk(
  "invoice/getCustomerInvoice",
  async (userId, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.getCustomerInvoice(userId);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const generateOrderInvoice = createAsyncThunk(
  "invoice/generateOrderInvoice",
  async (data, {rejectWithValue, dispatch}) => {
    try {
      const {onSuccess, orderIds, authType} = data;
      let timeOuts = null;
      const response = await InvoiceService.generateInvoice(orderIds);
      if (response && response.data) {
        const {username, signature, templateCode, invoiceSeri, authTypeInvoice, invoiceList} = response.data;
        if (Array.isArray(invoiceList) && invoiceList.length > 0) {
          dispatch(showLoading(true));
          if (authType === INVOICE_RELEASE) {
            timeOuts = invoiceList.map((invoice, idx)=>
              setTimeout(async () => {
                if ([HSM, SIGN_SERVER].includes(authTypeInvoice)) {
                  InvoiceService.createHSMInvoice(invoice).then(async invoiceResult => {
                    await InvoiceService.signInvoice({...invoiceResult.result, orderId: orderIds[idx]});
                    openNotification(
                      "success",
                      Utils.setLocale("admin.settings.popup.notification.createdInvoice"),
                      Utils.setLocale("admin.settings.popup.notification.title")
                    );
                  }).finally(() => {
                    if (idx === invoiceList.length - 1) {
                      dispatch(showLoading(false));
                      if (onSuccess) onSuccess();
                    }
                  });
                } else {
                  const hashUSB = await InvoiceService.createUSBHash(invoice).catch(() => {
                    dispatch(showLoading(false));
                  });
                  if (hashUSB && hashUSB.result) {
                    const payload = {
                      hashString: hashUSB.result.hashString,
                      supplierTaxCode: username,
                      templateCode: templateCode,
                      signature: signature,
                    };
                    InvoiceService.signatureUSBInvoice(payload).then(async invoiceResult => {
                      await InvoiceService.signInvoice({...invoiceResult.result, orderId: orderIds[idx]});
                      openNotification(
                        "success",
                        Utils.setLocale("admin.settings.popup.notification.createdInvoice"),
                        Utils.setLocale("admin.settings.popup.notification.title")
                      );
                    }).finally(() => {
                      if (idx === invoiceList.length - 1) {
                        dispatch(showLoading(false));
                        if (onSuccess) onSuccess();
                      }
                    });
                  }
                }
              }, idx * 1500));
          } else {
            invoiceList.forEach((invoice, idx) => {
              InvoiceService.createDraftInvoice({...invoice}).then(async () => {
                openNotification(
                  "success",
                  Utils.setLocale("admin.settings.popup.notification.createdInvoiceDraft"),
                  Utils.setLocale("admin.settings.popup.notification.title")
                );
                await InvoiceService.updateDraftInvoice({
                  orderId: orderIds[idx],
                  templateCode: templateCode,
                  invoiceSeri: invoiceSeri,
                });
                if (idx === invoiceList.length - 1) {
                  dispatch(showLoading(false));
                  if (onSuccess) onSuccess();
                }
              });
            });
          }
        } else {
          dispatch(showLoading(false));
          openNotification(
            "warning",
            'Vui lòng không chọn đơn đã bị huỷ!',
            Utils.setLocale("admin.settings.popup.notification.title")
          );
          return rejectWithValue("Vui lòng không xuất đơn đã huỷ!");
        }
      }

      return {...response.data, timeOuts};
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const createUSBTokenHash = createAsyncThunk(
  "invoice/createUSBTokenHash",
  async (data, {rejectWithValue}) => {
    try {
      const payload = cloneDeep(data);
      delete payload.orderId;
      return await InvoiceService.createUSBHash(payload);
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const createPDFInvoice = createAsyncThunk(
  "invoice/createPDFInvoice",
  async (data, {rejectWithValue}) => {
    try {
      return await InvoiceService.createPdfInvoice(data);
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const createDraftInvoice = createAsyncThunk(
  "invoice/createDraftInvoice",
  async (data, {rejectWithValue}) => {
    try {
      return await InvoiceService.createDraftInvoice(data);
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getInvoiceUuid = createAsyncThunk(
  "invoice/getInvoiceUuid",
  async (data, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.getInvoiceUuid(data);
      return response;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getInvoiceCertificate = createAsyncThunk(
  "invoice/getInvoiceCertificate",
  async (data, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.getCertificateInfo(data);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getBusinessVietQR = createAsyncThunk(
  "invoice/getBusinessVietQR",
  async (taxCode, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.searchBusiness(taxCode);
      const typeNoti = response && response.data ? "success" : "warning";
      openNotification(typeNoti, response?.desc, Utils.setLocale("admin.settings.popup.notification.title"));
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const sentInvoiceTax = createAsyncThunk(
  "invoice/sentInvoiceTax",
  async (data, {rejectWithValue}) => {
    try {
      const {onSuccess} = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await InvoiceService.sentInvoiceTax(payload);

      if (onSuccess) onSuccess(response);
      return response;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const changeStateSendInvoice = createAsyncThunk(
  'invoice/changeStateSendInvoice',
  async (data, {rejectWithValue}) => {
    try {
      const payload = cloneDeep(data);
      const {onSuccess} = payload;
      delete payload.onSuccess;
      const response = await InvoiceService.changeStateSendInvoice(payload);

      if (onSuccess) {
        onSuccess(response);
      }
      return response.data;
    } catch (ex) {
        return rejectWithValue(ex.message || 'Error');
    }
  },
);

export const updateInfoDraftExport = createAsyncThunk(
  "invoice/updateInfoDraftExport",
  async (data, {rejectWithValue}) => {
    try {
      const {onSuccess} = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await InvoiceService.updateDraftExport(payload);

      if (onSuccess) onSuccess(response);
      return response;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

// MeInvoice
export const loginMeInvoice = createAsyncThunk(
  "invoice/loginMeInvoice",
  async (data, {rejectWithValue}) => {
    try {
      const {onSuccess} = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await InvoiceService.loginMeInvoice(payload);
      console.log(response);
      if (response && response.success) {
        const now = new Date();
        localStorage.setItem(ACCOUNT_ME_INVOICE, {
          access_token: response.data,
          expired_at: now.setDate(now.getDate() + 7),
          ...payload,
        });
      }

      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getAllMeTemplate = createAsyncThunk(
  "invoice/getAllMeTemplate",
  async (payload, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.getMeInvoiceTemplates(payload);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const downloadMeInvoice = createAsyncThunk(
  "invoice/downloadMeInvoice",
  async (data, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.getPdfMeInvoice(data);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const getStatusMeInvoice = createAsyncThunk(
  "invoice/getStatusMeInvoice",
  async (data, {rejectWithValue}) => {
    try {
      return await InvoiceService.upSetStatusMeInvoice(data);
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const changeStatusMeInvoice = createAsyncThunk(
  "invoice/changeStatusMeInvoice",
  async (data, {rejectWithValue}) => {
    try {
      return await InvoiceService.changeStatusMeInvoice(data);
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const generateOrderMeInvoice = createAsyncThunk(
  "invoice/generateOrderMeInvoice",
  async (data, {rejectWithValue, dispatch}) => {
    try {
      const {onSuccess, orderIds, storeId} = data;
      const response = await InvoiceService.generateMeInvoice(orderIds);
      if (response && response.data) {
        const {meInvoiceList: invoiceData, authTypeInvoice} = response.data;
        if (Array.isArray(invoiceData) && invoiceData.length > 0) {
          const payload = {
            storeId: storeId,
            createInvoiceData: JSON.stringify({
              signType: authTypeInvoice,
              invoiceData: invoiceData,
            })
          }
          InvoiceService.createMeInvoiceData(payload).then(onSuccess);
          openNotification(
            "success",
            Utils.setLocale("admin.settings.popup.notification.createdInvoice"),
            Utils.setLocale("admin.settings.popup.notification.title")
          );
        }
      }
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const searchOrderInvoice = createAsyncThunk(
  "invoice/searchOrderInvoice",
  async (data, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.searchOrderInvoice(data);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const deleteOrderInvoice = createAsyncThunk(
  "invoice/deleteOrderInvoice",
  async (data, {rejectWithValue}) => {
    try {
      const response = await InvoiceService.deleteOrderInvoice(data);
      openNotification(
        "success",
        "Xóa hoá đơn thành công",
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(e.message || "Error");
    }
  }
);

export const invoiceSlice = createSlice({
  name: 'sInvoice',
  initialState,
  reducers: {
    showLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    clearTemplateList: (state) => {
      state.templateList = [];
    },
  },
  extraReducers : (builder) => {
    builder
      .addCase(getAllTemplate.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAllTemplate.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllTemplate.fulfilled, (state, action) => {
        state.templateList = action.payload.template;
        state.isLoading = false;
      })
      .addCase(getStoreInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getStoreInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.storeInvoice = action.payload;
      })
      .addCase(getStoreInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getOrderInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getOrderInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orderInvoice = action.payload;
      })
      .addCase(getOrderInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(upSetInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(upSetInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(upSetInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(upSetOrderInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(upSetOrderInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(upSetOrderInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getInvoiceUuid.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getInvoiceUuid.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getInvoiceUuid.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getBusinessVietQR.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getBusinessVietQR.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getBusinessVietQR.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(generateOrderInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(generateOrderInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(createPDFInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(createPDFInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(createPDFInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(sentInvoiceTax.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(sentInvoiceTax.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(sentInvoiceTax.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(changeStateSendInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(changeStateSendInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(changeStateSendInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateInfoDraftExport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(updateInfoDraftExport.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateInfoDraftExport.rejected, (state, action) => {
        state.isLoading = false;
      })
      // MeInvoice
      .addCase(getAllMeTemplate.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAllMeTemplate.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllMeTemplate.fulfilled, (state, action) => {
        state.templateList = action.payload.map(template => ({
          templateCode: template.invTemplateNo,
          invoiceSeri: template.invSeries,
        }));
        state.isLoading = false;
      })
      .addCase(generateOrderMeInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(generateOrderMeInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(generateOrderMeInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getStatusMeInvoice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getStatusMeInvoice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getStatusMeInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(searchOrderInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(searchOrderInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.invoiceOrder = {
          invoiceList: action.payload?.data ?? [],
          totalInvoicePending: action.payload?.totalInvoicePending ?? 0,
          totalInvoiceExported: action.payload?.totalInvoiceExported ?? 0,
        };
      })
      .addCase(searchOrderInvoice.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteOrderInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOrderInvoice.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteOrderInvoice.rejected, (state) => {
        state.isLoading = false;
      });
    }
});

export const {showLoading, clearTemplateList} = invoiceSlice.actions;

export default invoiceSlice.reducer;
